export interface Category {
  name: string;
  link: string;
  icon: string;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    link: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    imageSeq: 'cat-shoes-01',
  },
  {
    name: 'Hoodies / Sweaters',
    link: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    imageSeq: 'cat-hoodies-01',
  },
  {
    name: 'T-Shirts',
    link: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    imageSeq: 'cat-tshirts-01',
  },
  {
    name: 'Jackets',
    link: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    imageSeq: 'cat-jackets-01',
  },
  {
    name: 'Pants / Shorts',
    link: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    imageSeq: 'cat-pants-01',
  },
  {
    name: 'Headwear',
    link: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-shield-user-line',
    imageSeq: 'cat-headwear-01',
  },
  {
    name: 'Sets',
    link: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    imageSeq: 'cat-sets-01',
  },
  {
    name: 'Underwear / Underpants',
    link: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    imageSeq: 'cat-underwear-01',
  },
  {
    name: 'Jersey',
    link: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    imageSeq: 'cat-jersey-01',
  },
  {
    name: 'Accessories',
    link: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-vip-crown-line',
    imageSeq: 'cat-accessories-01',
  },
  {
    name: 'Bags',
    link: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-handbag-line',
    imageSeq: 'cat-bags-01',
  },
  {
    name: 'Belts',
    link: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    imageSeq: 'cat-belts-01',
  },
  {
    name: 'Perfumes',
    link: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    imageSeq: 'cat-perfumes-01',
  },
  {
    name: 'Other Stuff',
    link: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    imageSeq: 'cat-other-01',
  },
];

export const benefits = [
  {
    icon: 'ri-search-eye-line',
    title: 'Instant Product Search',
    description: 'Find exactly what you need across 14 curated categories without endless scrolling or manual browsing.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Trusted Seller Compare',
    description: 'Compare prices and seller ratings side by side to make confident purchasing decisions every time.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Safe Buying Guides',
    description: 'Follow step-by-step guides covering quality inspection, shipping protection, and seller verification.',
  },
];

export const faqs = [
  {
    question: 'Is VigorBuy Spreadsheet free to use?',
    answer: 'Yes, the VigorBuy Spreadsheet is completely free to browse. You can explore all product categories, compare sellers, and read our buying guides at no cost. Simply visit the main site through any of our navigation links to start discovering products.',
  },
  {
    question: 'How often is the VigorBuy Spreadsheet updated?',
    answer: 'The VigorBuy Spreadsheet is updated daily to ensure you always have access to the latest product listings, current prices, and active seller information. Our team continuously monitors product availability and market trends to keep everything fresh.',
  },
  {
    question: 'Is VigorBuy safe to use for international shopping?',
    answer: 'Absolutely. We prioritize buyer safety with comprehensive guides on quality control, shipping protection, and seller verification. Every product listing in the VigorBuy Spreadsheet is vetted through our quality checklist before being featured.',
  },
  {
    question: 'How do I find specific products in the spreadsheet?',
    answer: 'You can use our category navigation to browse by product type, or visit the main VigorBuy Sheet site for advanced search and filtering. Our 14 curated categories cover everything from shoes and clothing to accessories and perfumes.',
  },
  {
    question: 'Can beginners use the VigorBuy Spreadsheet?',
    answer: 'Yes, the VigorBuy Spreadsheet is designed for everyone. Whether you are a first-time international shopper or an experienced buyer, our organized layout and detailed buying guides make product discovery straightforward and intuitive.',
  },
];

export const comparisonData = [
  { feature: 'Product Discovery', vigorbuy: true, traditional: false },
  { feature: 'Seller Research', vigorbuy: true, traditional: false },
  { feature: 'Buying Guides', vigorbuy: true, traditional: false },
  { feature: 'Product Categories', vigorbuy: true, traditional: false },
  { feature: 'Price Comparison', vigorbuy: true, traditional: false },
  { feature: 'Daily Updates', vigorbuy: true, traditional: false },
];